module.exports = __webpack_public_path__ + "img/logo.3c94f1bb.svg";